import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {

    GetProductTypeList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/ProductType/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetProductTypeList2({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/ProductType/List2',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetWebProductTypeList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/ProductType/GetWebProductTypeList',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/productType.js